import React, { useEffect } from "react";
import "../Css/About.css";
import Footer from "./Footer";
import laptop from "../Components/image/laptop1.png";

import { FiPhoneCall } from "react-icons/fi";
import { SlLocationPin } from "react-icons/sl";
import { ImHourGlass } from "react-icons/im";
import Counter from "./Counter";
import Counter1 from "./Counter1";
import Counter2 from "./Counter2";
import { motion, useScroll } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
// import image1 from "../Components/image/image1.png";
function About() {
  useEffect(() => {
    document.title = "About me";
  });
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const { scrollYProgress } = useScroll();
  return (
    <div id="parent">
      <motion.div
        style={{
          scaleX: scrollYProgress,
          position: "fixed",
          top: 0,
          right: 0,
          left: 0,
          height: 4,
          transformOrigin: "0%",
          background: "blue",
        }}
      />
      <div id="firstcontainerparent" className="container-fluid">
        <div id="firstcontainer">
          <div className="row" id="">
            <div className="col m-2 p-2">
              <h1
                className="m-5 p-3"
                id="abouttext"
                data-aos="zoom-in"
                data-aos-anchor-placement="center-center"
              >
                About us
              </h1>
              <div className=" " id="aboutdetail" data-aos="zoom-in">
                My name is{" "}
                <i style={{ color: "red", textDecoration: "underline" }}>
                  Montu kharb{" "}
                </i>{" "}
                and I am a passionate IT student with a strong interest in the
                latest technologies and software development. I have always been
                intrigued by how computers work, and this curiosity has led me
                to pursue a career in the IT field. Currently, I am pursuing a
                degree in BCA at Pt.Neki Ram Sharma Gove.college (under Mdu
                University). Throughout my academic journey, I have gained a
                solid foundation in programming languages such as Java,
                Python,c, and C++,html,css,javascript, as well as various
                software development frameworks like AngularJS and ReactJS. I
                have also learned about various database management systems like
                MySQL, Oracle, and MongoDB. Apart from my academic pursuits, I
                have also been actively involved in various extracurricular
                activities. I have participated in hackathons and coding
                competitions where I have honed my programming skills and worked
                on innovative projects. I have also volunteered for several
                IT-related events where I have gained valuable experience
                working in a team. In addition to my technical skills, I possess
                excellent problem-solving and analytical skills. I am adept at
                breaking down complex problems into smaller, manageable
                components and coming up with creative solutions. I also have
                excellent communication skills, which allow me to work
                effectively in a team environment and convey my ideas clearly.
                My ultimate goal is to work as a software developer, where I can
                use my skills to create innovative solutions that make a
                difference in people's lives. I am excited about the
                possibilities that the IT field has to offer and am constantly
                learning and expanding my knowledge to stay on top of the latest
                trends and technologies. Thank you for taking the time to read
                my about me text. I am looking forward to the opportunities that
                lie ahead and am excited about the future of the IT industry.
              </div>
            </div>
            <div className="col m-5" id="laptop" data-aos="fade-up">
              <img src={laptop} alt="laptoppic" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        {/* <div className="container"> */}
          <div className="row" id="controw">
            <div
              className="col-xl-3"
              id="clh1"
              // data-aos="zoom-in"
            >
              <span>
                {" "}
                <i style={{ color: "red" }}>{<FiPhoneCall />}</i> CALL US
              </span>
              <br/>
              <span className="text-center">
                {" "}
                <br /> Phone : +91-805-920-360 <br />
                Email: montukharb868@gmail.com
              </span>
            </div>
            <div
              className="col-xl-3"
              id="clh1"
              // data-aos="zoom-in"
              >
              <span>
                {" "}
                <i style={{ color: "green" }}>{<SlLocationPin />} </i> LOCATION
              </span>
              <br/>
              <span>
                {" "}
                <br /> XPHV+VHF, Giwana, Haryana 131409 <br />
                Distt:Sonipat,teh:Gohana
              </span>
            </div>
            <div
              className="col-xl-3"
              id="clh1"
            >
              <span>
                <i style={{ color: "red" }}> {<ImHourGlass />}</i> HOURS
              </span> <br/>
              <span>
                <br />
                Monday – Friday …… 9 am to 8 pm,
                <br /> Saturday - Sunday …… 6 am – 9 pm
              </span>
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className="container-fluid">
        {/* <div className="container"> */}
          <div className="row" id="controw">
            <div className="col-xl-3"id="clh2">
              <span> SITE VISITS</span> <br/>
              <span
               
                style={{ color: "blue", fontSize: "60px" }}
              >
                <Counter2 />
              </span>
            </div>
            <div className="col-xl-3" id="clh2">
              <span> HAPPY CLIENTS</span> <br/>
              <span style={{ color: "red", fontSize: "60px" }}>
                <Counter1 />
              </span>
            </div>
            <div className="col-xl-3"id="clh2">
              <span>PROJECTS FINISHED</span> <br/>
              <span style={{ color: "green", fontSize: "60px" }}>
                <Counter />
              </span>
            </div>
          {/* </div> */}
        </div>
      </div>

      <div id="foter">
        <Footer />
      </div>
    </div>
  );
}
export default About;
